/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const SnapshotIcon = ({ width = 24, height = 24, hidden = false, title = 'Snapshot' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20 7.5V6h-2v6h2v-1.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5V14h-2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V2.5a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5Zm-5.073 19.02c-1.13-.1-1.148-1.009-1.148-2.145a10.338 10.338 0 0 0 2.428-6.159c0-3.73-2.123-6.216-5.178-6.216S5.85 14.486 5.85 18.216a10.339 10.339 0 0 0 2.429 6.159c0 1.136-.018 2.046-1.151 2.145-1.548.137-6.611 1.818-7.066 6.755A.686.686 0 0 0 .711 34h20.594a.688.688 0 0 0 .689-.687v-.038c-.456-4.937-5.519-6.62-7.067-6.755Z"
    />
  </svg>`;
};
